import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { all, call, put } from 'redux-saga/effects';
import TranslationSagas from '../i18n/sagas';
import AuthSagas from '../auth/sagas';
import { actions } from './redux';
var AppSagas = /*#__PURE__*/function () {
  function AppSagas() {
    _classCallCheck(this, AppSagas);
  }
  return _createClass(AppSagas, null, [{
    key: "init",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function init(ctx, pageSaga) {
      var pathname, query, asPath, initialProps, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            pathname = ctx.pathname, query = ctx.query, asPath = ctx.asPath;
            _context.next = 1;
            return call(AppSagas.updateRoute, {
              pathname: pathname,
              query: query,
              asPath: asPath
            });
          case 1:
            _context.next = 2;
            return call(AuthSagas.init, ctx);
          case 2:
            if (process.browser) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return all([call(AppSagas.loadInitialData), call(TranslationSagas.init, query.lang || 'en')]);
          case 3:
            _context.next = 4;
            return put(actions.setJsonld(null));
          case 4:
            if (!pageSaga) {
              _context.next = 6;
              break;
            }
            _context.next = 5;
            return call(pageSaga, ctx);
          case 5:
            _t = _context.sent;
            _context.next = 7;
            break;
          case 6:
            _t = {};
          case 7:
            initialProps = _t;
            if (ctx.res && ctx.res.statusCode > 400) {
              ctx.res.statusCode = 404;
            }
            if (ctx.res && initialProps && initialProps.error) {
              ctx.res.statusCode = initialProps.error;
            }
            return _context.abrupt("return", initialProps || {
              loaded: true
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, init);
    })
  }, {
    key: "loadInitialData",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function loadInitialData() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return call(AppSagas.requestInitialData);
          case 1:
            return _context2.abrupt("return", _context2.sent);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, loadInitialData);
    })
  }, {
    key: "requestInitialData",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function requestInitialData() {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
          case "end":
            return _context3.stop();
        }
      }, requestInitialData);
    })
  }, {
    key: "updateRoute",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function updateRoute(route) {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 1;
            return put(actions.setRoute(route));
          case 1:
          case "end":
            return _context4.stop();
        }
      }, updateRoute);
    })
  }, {
    key: "loop",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function loop() {
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 1;
            return all([
              //
            ]);
          case 1:
          case "end":
            return _context5.stop();
        }
      }, loop);
    })
  }]);
}();
export { AppSagas as default };